import { Dimensions, StyleSheet } from 'react-native'
import theme from '../../../theme'

const { width } = Dimensions.get('window')
const { height } = Dimensions.get('screen')

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        backgroundColor: 'white',
        alignItems: 'center',
        marginVertical: 8,
    },
    containerBis: {
        flex: 1,
        backgroundColor: 'white',
    },
    containerFlexTwo: {
        flex: 2,
    },
    containerProductListItem: {
        justifyContent: 'center',
        alignItems: 'flex-start',
    },
    containerDataProducts: {
        flex: 3,
        alignItems: 'flex-start',
        marginHorizontal: 12,
        flexDirection: 'column',
    },
    containerNameProduct: {
        flexDirection: 'row',
        justifyContent: 'center',
    },
    nameProduct: {
        fontSize: 16,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'left',
        lineHeight: 22,
        marginBottom: 4,
    },
    descriptionProduct: {
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.darkGray,
        textAlign: 'center',
        marginBottom: 10,
    },
    dataProduct: {
        fontSize: 15,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'left',
        marginVertical: 1,
    },
    imageProduct: {
        width: width / 3,
        height: undefined,
        aspectRatio: 1,
    },
    containerNoProducts: {
        flex: 1,
        backgroundColor: 'white',
        flexDirection: 'column',
        justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
    },
    brand: {
        width: width,
        height: 120,
        alignSelf: 'center',
    },
    image: {
        width: 120,
        height: 120,
    },
    title: {
        fontSize: 18,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        marginBottom: 5,
        marginTop: 10,
        paddingHorizontal: 40,
    },
    description: {
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.textSecondary,
        textAlign: 'center',
        paddingHorizontal: 40,
    },
    descriptionBrand: {
        fontSize: 13,
        fontWeight: 'normal',
        color: theme.colors.textPrimary,
        textAlign: 'center',
        lineHeight: 20,
        marginBottom: 16,
        paddingHorizontal: 12,
    },
    containerSeeMore: {
        flexDirection: 'row',
        alignItems: 'center',
        marginTop: 4,
    },
    seeMore: {
        fontSize: 13,
        fontWeight: 'bold',
        color: theme.colors.colorPrimary,
    },
    spacer: {
        height: 12,
    },
})
export default styles
